import { Canvas } from 'fabric';

export interface MnemonicViewportSceneBounds {
    left: number;
    top: number;
    right: number;
    bottom: number;
    width: number;
    height: number;
}

export function getMnemonicViewportSceneBounds(canvas: Canvas): MnemonicViewportSceneBounds {
    canvas.calcViewportBoundaries();

    const { tl, tr, bl, br } = canvas.vptCoords;
    const left = Math.min(tl.x, tr.x, bl.x, br.x);
    const top = Math.min(tl.y, tr.y, bl.y, br.y);
    const right = Math.max(tl.x, tr.x, bl.x, br.x);
    const bottom = Math.max(tl.y, tr.y, bl.y, br.y);

    return {
        left,
        top,
        right,
        bottom,
        width: right - left,
        height: bottom - top,
    };
}
